import React from 'react';
import Button from '../../../components/Button';
import Container from '../../../components/Container';
import Section from '../../../components/Section';
import styled from '../../../styled-components';
import AnswerVideoBox from './AnswerVideoBox';
import QuestionsBox from './QuestionsBox';

const HideOnDesktop = styled.div`
    @media (min-width: 800px) {
        display: none;
    }
`;

const HideOnMobile = styled.div`
    @media (max-width: 799px) {
        display: none;
    }
`;

const Layout = styled.div`
    display: flex;
    margin: 2rem -1rem;

    @media (min-width: 800px) {
        flex-wrap: wrap;
    }
`;
const ItemLeft = styled.div`
    flex: 1;
    margin: 1rem;
    @media (min-width: 800px) {
        flex: 1 1 18rem;
        border-right: 1px solid #d8d8d8;
        padding-right: 2em;
        padding-top: 1.4em;
        margin-right: 0;
    }
`;

interface Props {
    selected?: string;
}
const ItemRight = styled<Props, any>('div')`
    flex: 1;
    @media (min-width: 800px) {
        flex: 100 1 30rem;
        margin: 1rem;
        padding-left: 2rem;
        margin-left: 0;
    }
    @media (max-width: 799px) {
        background-color: white;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        transform: ${props => (props.selected ? `translate3d(0, 0, 0)` : 'translate3d(100vw, 0, 0)')};
        transition: transform 0.2s;
        padding: 1rem;
        overflow: auto;
        -webkit-overflow-scrolling: touch;
        z-index: 99;
    }
`;

export default ({
    url,
    application,
    currentQuestion,
    currentAnswer,
    retryAnswer,
    onClickQuestion,
    onClickNoQuestion,
    onRetry,
    handleNewAnswer
}) => (
    <Section>
        <Container>
            <h1>My answer videos</h1>
            <Layout>
                <ItemLeft>
                    <QuestionsBox
                        baseUrl={url}
                        questions={application.questions}
                        onClickQuestion={onClickQuestion}
                        answers={application.answers}
                        currentQuestion={currentQuestion}
                    />
                </ItemLeft>
                {currentQuestion ? (
                    <ItemRight selected={currentQuestion}>
                        <HideOnDesktop>
                            <Button
                                normal
                                style={{ marginTop: 20, marginBottom: 20 }}
                                onClick={() => onClickNoQuestion()}
                            >
                                Back to Questions
                            </Button>
                        </HideOnDesktop>
                        <h2>Question</h2>
                        <p>{currentQuestion.text}</p>
                        <AnswerVideoBox
                            question={currentQuestion}
                            answer={currentAnswer}
                            onNewAnswer={handleNewAnswer}
                            onRetry={onRetry}
                            retry={retryAnswer}
                            applicationId={application.id}
                            applicationState={application.applicationState}
                        />
                    </ItemRight>
                ) : (
                    <ItemRight selected={currentQuestion}>
                        <HideOnMobile>
                            <h3
                                style={{
                                    margin: '1.4em 0',
                                    padding: '2em',
                                    color: '#999',
                                    backgroundColor: '#eee'
                                }}
                            >
                                Please choose a question.
                            </h3>
                        </HideOnMobile>
                    </ItemRight>
                )}
            </Layout>
        </Container>
    </Section>
);



// WEBPACK FOOTER //
// ./src/scenes/candidate/components/QuestionSection.tsx